import { useContext } from "react";
import { YearlyCycleContext, type YearlyCycleContextType } from "./YearlyCycleContext";

export function useYearlyCycle(): YearlyCycleContextType {
    const context = useContext(YearlyCycleContext);
    if (!context) {
        throw new Error("useYearlyCycle must be used within a YearlyCycleContext.Provider");
    }
    return context;
}
